import {
  type ActivatedRouteSnapshot,
  type CanActivateChildFn,
  type CanActivateFn,
  RedirectCommand,
  Router,
  type RouterStateSnapshot,
} from '@angular/router';
import type { UserRole } from '@szebit-app/sdk/backend';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserStateSelectors } from '../state/user-state-selectors';
import { map } from 'rxjs/operators';

export const canActivateRoleGuard: (role: UserRole) => CanActivateFn = role => () => {
  const router = inject(Router);
  return inject(Store)
    .selectOnce(UserStateSelectors.hasAccess(role))
    .pipe(map(hasRole => (hasRole ? true : new RedirectCommand(router.parseUrl('/')))));
};

export const canActivateChildRoleGuard: (role: UserRole) => CanActivateChildFn =
  role => (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    canActivateRoleGuard(role)(childRoute, state);
